export default __webpack_public_path__ + "static/media/5e556d4a6e1b005a1082eff4569eedc0.svg";